exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bottom-navigation {\n  position: fixed !important;\n  bottom: 0;\n  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1), 0 -1px 2.5px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1), 0 -1px 2.5px 0 rgba(0, 0, 0, 0.1);\n  z-index: 10; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/BottomNavigation/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/BottomNavigation/index.css
// module chunks = 504